module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_mobile_4-df02fe899f0e7a5ba886cee1937ad2f4.png";